<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-purchases'>{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-purchases'>{{translations('purchase.archive_order')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('purchase.order_registration')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('purchase.order_date')}}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ purchaseInfo.purchase_at ? $invoiceTools.formatDateAt(purchaseInfo.purchase_at) : '-----------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.order_date')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model="tempInfo.purchase_at" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('purchase_at', tempInfo.purchase_at, 'info01')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.name')}}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ purchaseInfo.name ? purchaseInfo.name : '-----------' }}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.name')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.name" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('name', tempInfo.name, 'info02')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.client_order_number')}}</th>
                <td>
                  <button
                    ref='info03'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info03'
                    data-placement='right'
                  >{{ purchaseInfo.purchase_number ? purchaseInfo.purchase_number : '-----------' }}</button>
                  <div id='popover-info03' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.client_order_number')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input ref="input-info03" type='text' v-model="tempInfo.purchase_number" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('purchase_number', tempInfo.purchase_number, 'info03')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.payment_destination')}}</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ purchaseInfo.partner ? purchaseInfo.partner : '-----------' }}</button>
                  <div id='popover-info04' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.payment_destination')}}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempInfo.partner_id">
                        <option selected :value='0'>-</option>
                        <option v-for="(partner, i) in partners" :key="i" :value='partner.id'>{{ partner.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('partner_id', tempInfo.partner_id, 'info04')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.warehouse')}}</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ purchaseInfo.warehouse_name ? purchaseInfo.warehouse_name : '-----------' }}</button>
                  <div id='popover-info05' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.warehouse')}}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempInfo.warehouse_id">
                        <option selected value="-">-</option>
                        <option v-for="(warehouse, i) in warehouses" :key="i" :value='warehouse.id'>{{ warehouse.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('warehouse_id', tempInfo.warehouse_id, 'info05')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.stock_date')}}</th>
                <td>
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                  >{{ purchaseInfo.arrival_scheduled_at ? $invoiceTools.formatDateAt(purchaseInfo.arrival_scheduled_at) : '-----------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.stock_date')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model="tempInfo.arrival_scheduled_at" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('arrival_scheduled_at', tempInfo.arrival_scheduled_at, 'info08')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.remarks')}}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ purchaseInfo.memo ? purchaseInfo.memo : '-----------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <textarea v-model="tempInfo.memo" class='form-control'></textarea>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info07')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1100'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('purchase.jan_code')}}</th>
                  <th>{{translations('purchase.model')}}</th>
                  <th>{{translations('purchase.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th>{{translations('purchase.count')}}</th>
                  <th>{{translations('purchase.unit_price')}}</th>
                  <th></th>
                  <th>{{translations('purchase.summary')}}</th>
                  <th>{{translations('purchase.unit_price_total')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in purchaseDetails">
                  <tr :key="i">
                    <td>
                      <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.model }}</td>
                    <td>
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onChangePrice(detail)"
                      >
                        <option value="1">課税対象</option>
                        <option value="2">対象外</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td class="right">{{ Number(detail.quantity).toLocaleString() }}</td>
                    <template>
                      <td class="right">
                        <div class="number-container">
                          <input type="text" :placeholder="detail.row_price" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" @input="onChangePrice(detail, $event)"/>
                          <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span>
                        </div>
                      </td>
                      <td v-if="Number(detail.taxclass_id) === 1" class="right">({{ $util.getIncludeTax(detail.unit_price, detail.tax_rate).toLocaleString()}})</td>
                      <td v-else></td>
                    </template>

                    <td>{{ detail.remarks }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button
                      class='btn-change plus'
                      type='button'
                      data-toggle='modal'
                      data-target='#PurchaseDetailsModal'
                      @click="showModal"
                    >
                      <i></i>
                    </button>
                  </td>
                  <td></td><!-- TAXSTATUS -->
                  <td></td>
                  <td></td>
                  <th></th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ Number(grandTotalUnitPrice).toLocaleString() }} ({{ Number(grandTotalUnitPriceIncTax).toLocaleString() }})</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary' @click="addPurchase()">{{translations('common.update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PurchaseDetailsModal :details="purchaseDetails" :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"/><!-- VAT -->
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PurchaseDetailsModal from '@/components/purchase/PurchaseDetailsModal'
import { mapState } from 'vuex'

export default {
  name: 'NewPurchase',
  props: {},
  components: {
    VueElementLoading,
    PurchaseDetailsModal
  },

  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      ordersID: 0,
      purchaseInfo: {},
      purchaseDetails: [],
      tempInfo: {},
      grandTotalUnitPrice: null,
      grandTotalUnitPriceIncTax: null,
      isLoading: false
    }
  },

  computed: {
    ...mapState(['currentLanguage']),
    partners () {
      return this.$store.getters['Master/getPayTo']
    },
    warehouses () {
      return this.$store.getters['Master/getMywarehouses']
    }
  },

  watch: {
    purchaseDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
      },
      deep: true
    }
  },

  created () {
    this.purchaseInfo.purchase_at = this.$invoiceTools.getCurrentDate()
    this.$store.dispatch('Master/checkPayTo')
    this.$store.dispatch('Master/checkMywarehouses')

    Promise.all([
      this.getVatRate(), // VAT
      this.getSequence()
    ]).catch(err => {
      this.$toastr.error(err.message, 'エラー')
    }).finally(() => {
      this.popoverButtons()
    })
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getSequence () {
      return this.$http.post(this.$api_url.purchase_sequence).then(response => {
        const result = response.data
        if (result.status === true) {
          this.tempInfo.purchase_number = result.sequence
          this.purchaseInfo.purchase_number = result.sequence
          this.$refs['info03'].innerText = result.sequence
          this.$refs['input-info03'].value = result.sequence
          return Promise.resolve()
        } else {
          return Promise.reject(result)
        }
      }).catch(error => {
        console.log('NewPurchase:getSequence:catch(error): ', error)
        return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
      })
    },
    getVatRate () { // VAT
      return this.$http.post(this.$api_url.vat_rate).then(response => {
        const result = response.data
        if (result.status === true) {
          this.vatRate = result.vat_rate
          return Promise.resolve()
        } else {
          return Promise.reject(result)
        }
      }).catch(error => {
        console.log('NewPurchase:getVatRate:catch(error): ', error)
        return Promise.reject(new Error('消費税率が取得できませんでした。'))
      })
    },
    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : orders information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let val = ''
      const rg = /^\s+$/
      if (
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '-----------'
        val = ''
      } else if (field === 'purchase_at') {
        this.$refs[ref].innerText = this.$invoiceTools.formatDateAt(value)
        val = value
      } else if (field === 'arrival_scheduled_at') {
        this.$refs[ref].innerText = this.$invoiceTools.formatDateAt(value)
        val = value
      } else if (field === 'partner_id') {
        const partner = this.partners.find(partner => partner.id === value)
        if (partner) {
          val = Number(partner.id)
          this.tempInfo.partner_id = val
          this.$refs[ref].innerText = partner.name
          this.taxIncluded = Number(partner.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
        } else {
          this.tempInfo.partner_id = 0
          this.$refs[ref].innerText = '-----------'
        }
      } else if (field === 'warehouse_id') {
        const warehouse = this.warehouses.find(warehouse => warehouse.id === value)
        if (warehouse) {
          val = Number(warehouse.id)
          this.tempInfo.warehouse_id = val
          this.$refs[ref].innerText = warehouse.name
        } else {
          this.tempInfo.warehouse_id = 0
          this.$refs[ref].innerText = '-----------'
        }
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.purchaseInfo[field] = val

      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.purchaseDetails.splice(i, 1)
    },

    showModal () {
      this.$root.$emit('bv::show::modal', 'PurchaseDetailsModal')
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_unit_price = data.quantity * data.unit_price

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.unit_price_inctax = Number(data.unit_price)
        data.total_unit_price_inctax = Number(data.total_unit_price)
      } else {
        data.unit_price_inctax = this.$util.getIncludeTax(data.unit_price, Number(data.tax_rate || this.taxRate))
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0

      this.purchaseDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
      })

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
    },

    addPurchase () {
      if (this.purchaseDetails.length === 0) {
        this.$toastr.warning('詳細行を入力してください。')
        return
      }
      if (this.purchaseInfo.purchase_number === undefined || this.purchaseInfo.purchase_number === '') {
        this.$toastr.warning('発注番号を入力してください。')
        return
      }

      if (this.purchaseInfo.partner_id === undefined || this.purchaseInfo.partner_id === '') {
        this.$toastr.warning('支払先を選択してください。')
        return
      }

      this.$dialog.confirm('この発注を保存しますか?').then(async () => {
        try {
          this.isLoading = true

          this.purchaseInfo.total_amount = this.grandTotalUnitPriceIncTax

          let paramUpdate = {
            information: this.purchaseInfo,
            details: this.purchaseDetails
          }
          console.log('NewPurchase:', paramUpdate)

          let updateOrder = await this.$http.post(this.$api_url.purchase_add, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updateOrder.data)

          console.log('NewPurchase:addPurchase: ', $data)
          if ($data.success === true) {
            this.$toastr.success('発注の保存に成功しました。', 'Success')
            this.$router.replace('archive-purchases')
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
          this.isLoading = false
        } catch (error) {
          console.log('NewPurchase:addPurchase:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    onChangePrice (detail, e) {
      if (e) {
        e.target.nextElementSibling.innerText = Number(e.target.value).toLocaleString()
      }
      this.purchaseDetails.forEach((detail, i) => {
        this.purchaseDetails[i] = this.prepareDetails(detail)
      })
      this.calcGrandTotals()
    }
  }
}
</script>
